/* eslint-disable quotes */
import { getApiV1SurveyDocumentGroups, SurveyStageResource } from "@konova/api";
import { useAsync } from "@konova/ui/use-async";
import assert from "assert";
import { isAfter, isBefore } from "date-fns";
import { useEffect, useMemo } from "react";

/**
 * @TODO remove this when header is refactored
 * @deprecated DO NOT USE THIS ANYWHERE ELSE!
 * @see https://konova.atlassian.net/browse/EMI-5725
 */
export const useShowLoginButtonBasedOnSurveyContent = (
  surveyId: number | null,
) => {
  const surveyDocumentGroups = useAsync(async () => {
    assert(surveyId, 'surveyid is required');
    const response = await getApiV1SurveyDocumentGroups({
      query: {
        per_page: 999,
        "filter[survey_id]": surveyId!,
        page: "participant",
      },
    });
    return response.data?.data;
  });

  useEffect(() => {
    if (!surveyId) return;

    surveyDocumentGroups.run();
  }, [surveyId]);

  const hasInteractiveDocuments = useMemo(
    () =>
      (surveyDocumentGroups.data ?? [])
        .filter(group => isAfter(new Date(), new Date((group.survey_stage! as SurveyStageResource).date_start!)) && isBefore(new Date(), new Date((group.survey_stage! as SurveyStageResource).date_end!)))
        .some(
          group => group.show_in_all_stages || !group.show_in_info_section,
        ),
    [surveyDocumentGroups.data],
  );

  return hasInteractiveDocuments;
};